export default class RenderSettingsService {
    public countUpEnabled = true;
    public videoPlayerEnabled = true;
    public imagePreloadEnabled = true;
    public omitHiddenContent = false;
}
